import React from "react";
import { Link } from "gatsby";
var TextLinks = function TextLinks(_ref) {
    var edition = _ref.edition, spotlight = _ref.spotlight;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "hidden pl-2 lg:flex flex-wrap justify-between block text-2xl tracking-wider",
        style: {
            maxWidth: "39rem"
        }
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/" + edition.slug + "/",
        className: "block lg:inline-block lg:hover:text-makroOrange",
        activeClassName: "font-bold text-makroOrange current-edition-active",
        partiallyActive: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "font-light text-xl hidden -mt-2 -mb-8"
    }, "NR ", edition.label))));
};
export default TextLinks;
